// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"743212c2dd0a1b386b8b","453":"927c9cab7d9bfd2254a3"}[chunkId] + ".js";
};